import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blackwood",
  "use": "blackwood-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"blackwood\">\n    <path d=\"M10.746.44L.75 10.01l9.996 9.565L20.75 10.01 10.746.44zm0 2.207l7.69 7.357-6.699 6.41V14.31l4.51-4.317-5.484-5.246L9.4 6.068l4.112 3.935-.685.656-4.122-3.94-1.37 1.312 4.113 3.936-.685.656-4.114-3.935-1.371 1.31 4.52 4.325v2.127L3.056 10l7.69-7.353z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol